import React, { useContext, useEffect, useState } from 'react'
import {
  Card,
  Button,
  Carousel,
  Typography,
  message,
  Row,
  Col,
  Tag
} from 'antd'
import { FaBed, FaEdit } from 'react-icons/fa'
import { AiFillCar } from 'react-icons/ai'
import { BsArrowsMove } from 'react-icons/bs'
import { GiCancel } from 'react-icons/gi'
import AppContext from '../context/Context'
import { getProperties, remove } from '../services/request'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Meta from 'antd/es/card/Meta'

const { Text } = Typography

export default function Cards (products) {
  const {
    id,
    local,
    images,
    tipo,
    valor,
    dormitorios,
    garagem,
    au,
    codigo,
    descricao
  } = products
  const [cardWidth, setCardWidth] = useState(350)
  const [cardHeigth, setCardHeight] = useState(520)

  const { user, items, setItems, filter, setProduct, setEditMode, setLoading } =
    useContext(AppContext)

  const history = useHistory()
  const host = process.env.REACT_APP_API_URL || 'http://localhost:3001'

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCardWidth('100%')
        return setCardHeight(null)
      }
      setCardWidth('100%')
      if (window.innerWidth <= 1280) {
        setCardHeight(530)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setItems(items)
  }, [items])

  const handleRemove = async () => {
    const item = await getProperties(filter, host)
    setItems(item)
  }

  return (
    <Card
      style={{
        height: cardHeigth,
        width: cardWidth,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column'
      }}
      cover={
        <div
          style={{
            height: 250,
            width: '100%'
          }}
        >
          <Carousel arrows={!(window.innerWidth <= 768)} infinite>
            {images && images.length > 0
              ? (
                images
                  .sort((a, b) => Number(a.id) - Number(b.id))
                  .map(({ id }) => {
                    return (
                      <div
                        style={{
                          height: 250,
                          width: '100%'
                        }}
                        key={id}
                      >
                        <img
                          src={`${host}/products/image/${id}`}
                          alt="Produto"
                          style={{
                            width: '100%',
                            height: 250,
                            objectFit: 'fill'
                          }}
                        />
                      </div>
                    )
                  })
              )
              : (
                <img
                  src="/no-image.png"
                  alt="Sem imagem"
                  style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover'
                  }}
                />
              )}
          </Carousel>
        </div>
      }
    >
      <Meta
        title={local && local[0].toUpperCase() + local.slice(1)}
        description={descricao.charAt(0).toUpperCase() + descricao.slice(1)}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap',
          padding: '5px 0',
          fontSize: 13
        }}
      >
        {dormitorios > 0 && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <FaBed /> Dormitórios: {dormitorios}
          </span>
        )}
        {garagem > 0 && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <AiFillCar /> Garagem: {garagem}
          </span>
        )}
        {au && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <BsArrowsMove /> Área: {au}
          </span>
        )}
      </div>
      <div>
        <Tag style={{ width: '100%', textAlign: 'center' }}>
          {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
        </Tag>
      </div>
      <Text strong style={{ fontSize: 20 }}>
        {Number(valor.replace('R$', '')).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })}
      </Text>

      <Row gutter={[8, 8]} style={{ marginTop: 10 }}>
        <Col xs={user && user.role === 'admin' ? 8 : 24}>
          <Button
            type="primary"
            size="small"
            style={{
              background: '#64748B',
              width: '100%',
              border: 'none'
            }}
            block
            onClick={() => {
              history.push(`/details?code=${codigo}`)
            }}
          >
            Ver mais
          </Button>
        </Col>
        {user && user.role === 'admin' && (
          <Col xs={8}>
            <Button
              type="default"
              size="small"
              icon={<FaEdit />}
              block
              onClick={() => {
                setProduct(products)
                setEditMode(true)
                history.push('/products')
              }}
            />
          </Col>
        )}
        {user && user.role === 'admin' && (
          <Col xs={8}>
            <Button
              type="dashed"
              size="small"
              danger
              icon={<GiCancel />}
              block
              onClick={async () => {
                try {
                  setLoading(true)
                  await remove(id, host)
                  await handleRemove()
                  message.success('Produto removido com sucesso!')
                } catch (error) {
                  message.error('Erro ao remover o produto!')
                } finally {
                  setLoading(false)
                }
              }}
            />
          </Col>
        )}
      </Row>
    </Card>
  )
}
